/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 09.01.13, 15:17
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { AbstractTextContentVO } from "@goodgamestudios/localization";
import { HTMLTextVO } from "@goodgamestudios/localization";
import { LocalizedTextVO } from "@goodgamestudios/localization";
import { TextValide } from "../../stringhelper/TextValide";
import { GGSCountryController } from "../../language/countryMapper/GGSCountryController";
import { GoodgameTextField } from "./GoodgameTextField";
import { IBasicInputGGSTextField } from "./IBasicInputGGSTextField";
import { IBasicGGSTextField } from "./IBasicGGSTextField";
import { debug } from "../../logging/debug";

import { TextField } from "@goodgamestudios/createjs-utilities";

export class GoodgameInputTextField extends GoodgameTextField implements IBasicInputGGSTextField {
    public static NAME: string = "GoodgameInputTextField";
    private _textContentDefaultVO: AbstractTextContentVO;
    private _displayAsPassword: boolean;
    // If the user has entered some text we should not refresh it to a localized string
    // (ie. in the start screen if you enter a user name it shouldn't revert when changing languages)
    // Thus we track if the user has written something, if so we do NOT call super.resolveTextContent()
    private _userWroteSomething: boolean = false;

    constructor(textfield: TextField) {
        super(textfield);

        this.updateStrategyListeners();

        this.selectable = true;
    }

    protected updateStrategyListeners(): void {
        this.focusOut.add(this.bindFunction(this.restoreDefaultTextContentForEmptyTextFields));
        this.focusIn.add(this.bindFunction(this.removeDefaultTextContent));
    }

    protected resolveTextContent(textContentVO: AbstractTextContentVO): void {
        if (textContentVO instanceof HTMLTextVO) {
            throw new Error(GoodgameInputTextField.NAME + ", resolveTextContent() -> Input TextFields doesn't support HTMLTextVOs.");
        }
        if (this.text != "" && this._userWroteSomething) {
            return;
        }

        super.resolveTextContent(textContentVO);
    }

    /**
     * Remove default text content on focus in
     */
    private removeDefaultTextContent(textField: IBasicGGSTextField): void {
        //          trace("GoodgameInputTextField, removeDefaultTextContent(): text: " + _model.text + ", default text: " + _model.textDefault);

        let enteredText: string = this._model.text;

        // Trim passwords
        if (this.displayAsPassword) {
            enteredText = TextValide.trimPassword(enteredText)
        }

        if (enteredText == this._model.textDefault) {
            this.text = "";
            this._userWroteSomething = true;
        }
    }

    /**
     * Restore default text content String if the TextField remains empty on focus out
     */
    private restoreDefaultTextContentForEmptyTextFields(textField: IBasicGGSTextField): void {
        //          trace("GoodgameInputTextField, restoreDefaultTextContentForEmptyTextFields() text: " + _model.text + ", default text: " + _model.textDefault + " _textContentDefaultVO: " + _textContentDefaultVO);

        if (this._textContentDefaultVO) {
            let enteredText: string = this.text;

            // Trim passwords
            if (this.displayAsPassword) {
                enteredText = TextValide.trimPassword(enteredText)
            }

            if (enteredText == "") {
                this.text = this._textContentDefaultVO.compose();
                this._userWroteSomething = false;
            }
        }

        // TODO: Passwort unverschlüsselt darstellen?
        //			registerDisp.mc_password.txt_input.displayAsPassword = false;
    }

    public displayText(): void {
        if (this._textContentVO instanceof HTMLTextVO) {
            // Error: HTML text is not allowed in input text fields!
            return;
        }

        let textToDisplay: string = this._model.text;

        // Cut text if maxChars is set
        if (!isNaN(this._model.maxChars) && (this._model.maxChars > 0) && !this.containsDefaultTextContent) {
            textToDisplay = this._model.text.slice(0, this._model.maxChars);
        }

        // Null check
        if (textToDisplay === null) {
            // Prevent null pointer
            textToDisplay = "";
            this.printOutDebugInfos();
        }

        if (this._textContentDefaultVO instanceof LocalizedTextVO) {
            this._model.textDefault = ((<LocalizedTextVO>this._textContentDefaultVO)).compose();
        }

        if (this._displayAsPassword) {
            if (this.text != this._model.textDefault || this._model.textDefault == "") {
                this._model.displayAsPassword = true;
            }
            else {
                this._model.displayAsPassword = false;
            }
        }

        this._textStrategy.displayText(textToDisplay);
    }

    public get textContentDefaultVO(): AbstractTextContentVO {
        return this._textContentDefaultVO;
    }

    public set textContentDefaultVO(vo: AbstractTextContentVO) {
        if (vo instanceof HTMLTextVO) {
            throw new Error(GoodgameInputTextField.NAME + "textContentDefaultVO() -> Input TextFields doesn't support HTMLTextVOs.");
        }

        this._textContentDefaultVO = vo;
        this._model.textDefault = vo.compose();
    }

    public get containsDefaultTextContent(): boolean {
        return this._textStrategy.containsDefaultTextContent;
    }

    public get displayAsPassword(): boolean {
        return this._displayAsPassword;
    }

    public set displayAsPassword(value: boolean) {
        this._displayAsPassword = value;
        if ( this._originalTextField ) {
            this._originalTextField.displayAsPassword = value;
        }
    }
}
